import { type FC } from 'react';

import { inject } from '@vakantiesnl/services/src/util/template';
import { type MicroCopy, type Search } from '@vakantiesnl/types/src';

import { useCustomStyles } from './FlightInclusives.styles';
import { Icon } from '../../atoms/Icon';
import { Typography } from '../../atoms/Typography';

type Props = {
	inbound: Search.Flight;
	outbound: Search.Flight;
	microCopy: MicroCopy;
	isLuggageInclusive: boolean;
	isTransferInclusive: boolean;
	containerClassName?: string;
	flexDirection?: 'column' | 'row';
};

export const FlightInclusives: FC<Props> = ({
	microCopy,
	inbound,
	outbound,
	isLuggageInclusive,
	isTransferInclusive,
	containerClassName,
	flexDirection = 'column',
}) => {
	const { classes, cx } = useCustomStyles({ flexDirection });

	const hasInclusives = isTransferInclusive || isLuggageInclusive;

	if (!hasInclusives) {
		return null;
	}

	const maxWeight = Math.min(inbound.luggage?.weightAdult || 0, outbound.luggage?.weightAdult || 0);

	return (
		<div className={cx(containerClassName, classes.container)}>
			{isLuggageInclusive && (
				<div className={classes.inclusive}>
					<Icon type="luggage" />
					<Typography variant="labelXs" as="span">
						{inject(microCopy['accommodation.flight.max_luggage_included_label'], {
							amount: maxWeight.toString(),
						})}
					</Typography>
				</div>
			)}
			{isTransferInclusive && (
				<div className={classes.inclusive}>
					<Icon type="transfer" />
					<Typography variant="labelXs" as="span">
						{microCopy['transferInclusive']}
					</Typography>
				</div>
			)}
		</div>
	);
};
